import React from "react";
import "./floral.css";

const FloralFront = ({ data }) => {
  const { first_name, second_name, date } = data;

  return (
    <>
      <div className="postcard-wrapper postcard-floral postcard-front">
        <div className="postcard-safe">
          <div className="postcard-details postcard-front">
            <h1>SAVE THE DATE</h1>
            <p className="postcard-names">
              {first_name} & {second_name}
            </p>
            <p className="postcard-date">{date}</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default FloralFront;
